import { Box } from '@material-ui/core';
import { WbTooltip } from '@agilelab/plugin-wb-platform';
import { Task } from '../EditorPage/types';
import {
  GovernanceTestOverviewMetric,
  MetricHeader,
  roundWithoutApprossimation,
} from '@agilelab/plugin-wb-governance';
import { Metric } from '@agilelab/plugin-wb-governance-common';
import { CodeField, GenericField } from '@agilelab/plugin-wb-platform';
import { FC } from 'react';
import { format, parseISO } from 'date-fns';

interface Props {
  task: Task;
  metric: Metric;
}

export const MetricDetailDrawerContent: FC<Props> = ({ task, metric }) => {
  return (
    <Box>
      <MetricHeader
        name={metric.name}
        task={{
          value: task.metricSpecificResult?.value || 0,
          thresholdResult: task.metricSpecificResult?.threshold,
          hasError: task.errors && task.errors.length > 0,
        }}
      />
      <GovernanceTestOverviewMetric
        kind="tabs"
        metric={metric}
        test={{
          errors: task.errors,
          content: task.validatedDescriptor || '',
          name: task.displayName,
        }}
        infoContent={
          <Box style={{ display: 'flex', gap: 50 }}>
            <WbTooltip title={task.metricSpecificResult?.value || ''}>
              <Box>
                <GenericField
                  label="Value"
                  value={roundWithoutApprossimation(
                    2,
                    task.metricSpecificResult?.value,
                  )}
                />
              </Box>
            </WbTooltip>

            <>
              <GenericField
                label="Latest Update"
                value={format(parseISO(task.startTime), 'yyyy/MM/dd HH:mm:ss')}
              />

              <GenericField
                label="Label"
                value={
                  task.metricSpecificResult?.threshold?.label || 'No Label'
                }
              />
              {task.metricSpecificResult?.details && (
                <GenericField
                  label="Test Detail"
                  value={
                    <CodeField
                      title="Test Detail"
                      value={JSON.stringify(
                        task.metricSpecificResult?.details,
                        null,
                        4,
                      )}
                    />
                  }
                />
              )}
            </>
          </Box>
        }
      />
    </Box>
  );
};
